// Fixed deadline: token refresh never extends the chosen seven-day window.
const KEY = 'otomator-admin-session-until'
const SESSION_KEY = 'sb-dgxnnwnugdxzeopleera-auth-token'
const WEEK = 7 * 24 * 60 * 60 * 1000
export function rememberAdminSession(remember: boolean) {
  localStorage.removeItem(SESSION_KEY)
  if (remember) localStorage.setItem(KEY, String(Date.now() + WEEK))
  else localStorage.removeItem(KEY)
}
export const adminSessionStorage = {
  getItem(key: string) {
    const marker = localStorage.getItem(KEY)
    const until = Number(marker)
    if (marker !== null && (!Number.isFinite(until) || until <= Date.now())) {
      localStorage.removeItem(key); sessionStorage.removeItem(key); return null
    }
    if (until > Date.now() && until <= Date.now() + WEEK) return localStorage.getItem(key)
    localStorage.removeItem(key)
    localStorage.removeItem(KEY)
    return sessionStorage.getItem(key)
  },
  setItem(key: string, value: string) {
    const marker = localStorage.getItem(KEY)
    const until = Number(marker)
    if (marker !== null && (!Number.isFinite(until) || until <= Date.now())) {
      localStorage.removeItem(key); sessionStorage.removeItem(key); return
    }
    if (until > Date.now()) { localStorage.setItem(key, value); sessionStorage.removeItem(key) }
    else { sessionStorage.setItem(key, value); localStorage.removeItem(key) }
  },
  removeItem(key: string) {
    localStorage.removeItem(key)
    sessionStorage.removeItem(key)
    // Supabase also removes auxiliary keys when saving or refreshing a session.
    // Only removal of the session itself represents a logout.
    if (key === SESSION_KEY) localStorage.removeItem(KEY)
  },
}
export function adminSessionExpired() {
  const until = localStorage.getItem(KEY)
  return until !== null && (!Number.isFinite(Number(until)) || Number(until) <= Date.now())
}
